import { render, staticRenderFns } from "./PageBlock.vue?vue&type=template&id=60899b71&"
import script from "./PageBlock.vue?vue&type=script&lang=js&"
export * from "./PageBlock.vue?vue&type=script&lang=js&"
import style0 from "./PageBlock.vue?vue&type=style&index=0&id=60899b71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports